import React, { useState, useEffect } from 'react'
import { useSnackbar } from 'notistack'
import { useForm } from 'react-hook-form'
import { useStyles } from './FormInformationStyle'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../../../redux/actions/user'
import TabNavigation from '../../TabNavigation/TabNavigation'
import FilePicker from '../FilePicker/FilePicker'

//Material UI
import TextField from '@material-ui/core/TextField'
import Switch from '@material-ui/core/Switch'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from '@material-ui/core/FormHelperText'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import AddIcon from '@material-ui/icons/Add'


export default function FormInformation(props) {

  const dispatch = useDispatch()
  const classes = useStyles()
  const { formClass, defaultValues, refresh, professions, id, nextTab, previousTab } = props
  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''

  const { register, handleSubmit, errors, setValue, setError, clearErrors } = useForm()
  const { enqueueSnackbar } = useSnackbar()
  const [img, setimg] = useState(defaultValues?.photo ?? '')
  const [newsLetter, setNewsLetter] = useState(defaultValues?.newsLetter ? true : false)
  const [civilite, setCivilite] = useState(defaultValues?.civilite ?? '')
  const [profession, setProfession] = useState(defaultValues?.profession ?? '')

  async function save(data, e) {

    if (img === '') data.photo = ''
    else if (img === defaultValues?.photo) data.photo = defaultValues?.photo
    else data.photo = await toBase64(data.photo[0])

    data = { ...data, civilite, profession, category: 0 }
    const result = await allActions.fetchPostAPI(`api/users/modifs-infos-perso/${id}`, data, dispatch, token)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
      return
    }

    //Si le serveur retourne une erreur elle est affiché
    if (result?.json.err) {
      enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
      return
    }

    enqueueSnackbar('Enregistré !', { variant: `success` })
    refresh(result.json.data)

    const action = e.nativeEvent.submitter.dataset.action
    if (action === 'previous' && previousTab) previousTab()
    else if (action === 'next') nextTab()
  }

  /**
   * Check if the file is a valide image
   * @param {*} files 
   * @returns {Boolean} is valid
   */
  function isImageValid(files) {
    return new Promise(async (res) => {

      if (!files[0]) res(true)
      else {
        const file = files[0]
        const image = new Image()
        const base64 = await toBase64(file)
        image.src = base64
        image.onload = () => {
          if (file.size > 1000000) res({ value: false, err: 'Ce fichier est trop lourd (1mo max)' })
          else res({ value: true })
        }
        image.onerror = () => res({ value: false, err: 'Ce fichier n\'est pas une image' })
      }

    })
  }

  /**
   * Update the image preview with a form file image
   * @param {*} e (event)
   */
  async function filePreview(e) {

    const valid = await isImageValid(e.target.files)
    if (valid.value) {
      if (e.target.files[0]) setimg(URL.createObjectURL(e.target.files[0]))
      else setimg('')
      clearErrors('photo')
    }
    else {
      setError('photo', { type: 'manual', message: valid.err })
      setimg('')
      setValue('photo', null)
    }
  }


  function toBase64(file) {
    return new Promise(res => {
      const reader = new FileReader()
      reader.addEventListener('load', () => {
        res(reader.result)
      }, false)

      reader.readAsDataURL(file)
    })
  }

  /**
   * Clear the image from the file input
   */
  function clearImage() {
    setValue('photo', '', { shouldValidate: true })
    setimg('')
  }


  return (
    <form onSubmit={handleSubmit(save)}>
      <div className={formClass} >
        <TextField
          label="Numéro d'abonné"
          variant="outlined"
          type="text"
          name="numAbo"
          margin="dense"
          disabled
          defaultValue={defaultValues?.numAbo}
        ></TextField>

        <div className={classes.namesLine}>
          <TextField
            select
            label=" "
            variant="outlined"
            value={civilite}
            onChange={(e) => setCivilite(e.target.value)}
            margin="dense"
            required
          >
            <MenuItem value="M.">M.</MenuItem>
            <MenuItem value="Mme">Mme</MenuItem>
          </TextField>
          <TextField
            label="Nom"
            variant="outlined"
            type="text"
            name="nom"
            margin="dense"
            required
            inputRef={register}
            defaultValue={defaultValues?.nom}
          ></TextField>

          <TextField
            label="Prénom"
            variant="outlined"
            type="text"
            name="prenom"
            margin="dense"
            required
            inputRef={register}
            defaultValue={defaultValues?.prenom}
          />
        </div>

        

        <div className={classes.prefessionLine}>
          <TextField
            select
            label="Profession"
            variant="outlined"
            value={profession}
            onChange={(e) => setProfession(e.target.value)}
            margin="dense"
            fullWidth
            required
          >
            {professions.map((p, i) => (<MenuItem value={p.id} key={i}>{p.libelle}</MenuItem>))}
          </TextField> 
        </div>

        <FormControlLabel
          className={classes.switch}
          control={<Switch
            color="primary"
            onChange={(e) => setNewsLetter(e.target.checked)}
            checked={newsLetter}
            inputProps={{ ref: register, name: 'newsLetter' }}
          />}
          label="Recevoir des newsletter par mail"
          labelPlacement="start"
        />


        <div>
          <p style={{ marginTop: 0 }}>Choissisez une photo de profil :</p>
          <div className={`${classes.newFile} ${(img !== '') ? classes.fileHide : ''}`} >
            <div><IconButton><AddIcon /></IconButton></div>
            <input type="file"
              name="photo"
              ref={register({
                validate: { asyncValidate: async (value) => { return await isImageValid(value).value }, },
              })}
              accept="image/*"
              onChange={filePreview} />
          </div>


          {img !== '' &&
            <div className={classes.filePreview}>
              <div className={classes.clearBtn}>
                <IconButton aria-label="delete" onClick={clearImage}  >
                  <CloseIcon />
                </IconButton>
              </div>
              <div style={{ backgroundImage: `url(${img})` }} className={classes.img} />
            </div>
          }

          {errors.photo && <FormHelperText error>{errors.photo.message}</FormHelperText>}
        </div>


      </div>

      <TabNavigation save next/>
    </form>
  )
}